import { SparklesIcon } from "@heroicons/react/24/outline";
import { POPULAR_ACCENT_COLOR } from "@utils/types";

import { Divider, Paragraph } from "@fronterahealth/frontera-ui-components";

import { type GetCommunityPostsOutput } from "@api/rest/types-and-hooks";
import { PostSearchDropdown } from "@components/PostSearchDropdown/PostSearchDropdown";

import { PostRow } from "./PostRow";

interface PopularSectionProps {
  post: GetCommunityPostsOutput | null;
  description: string;
  onSelectPost: (post: GetCommunityPostsOutput) => void;
  onRemovePost: () => void;
  onDescriptionChange: (val: string) => void;
}

export const PopularSection: React.FC<PopularSectionProps> = ({
  post,
  description,
  onSelectPost,
  onRemovePost,
  onDescriptionChange,
}) => (
  <div className="rounded-xl border border-border-medium bg-bg-surface p-4 flex flex-col gap-y-3">
    <div className="flex items-center gap-x-3">
      <span className="inline-flex items-center gap-x-1 rounded-full bg-amethyst-100 text-amethyst-700 px-2 py-0.5 text-xs font-medium">
        <SparklesIcon className="h-3 w-3" />
        Popular this week
      </span>
      <Paragraph size="small" colorType="secondary" className="ml-1">
        This post appears at the top of the digest with extra visibility.
      </Paragraph>
    </div>
    <Divider className="my-0 -mx-4" />
    <div className="flex flex-col gap-y-3">
      {post ? (
        <PostRow post={post} accentColor={POPULAR_ACCENT_COLOR} showDragHandle={false} onRemove={onRemovePost} />
      ) : (
        <PostSearchDropdown
          placeholder="Search and select a post to feature..."
          excludePostIds={[]}
          onSelect={onSelectPost}
        />
      )}
      {post && (
        <div className="flex flex-col gap-y-1">
          <label className="text-xs text-text-secondary">Description</label>
          <textarea
            className="w-full rounded-lg border border-border-medium bg-bg-default px-3 py-2 text-sm text-text-primary placeholder:text-text-tertiary outline-none focus:border-border-focus resize-none"
            rows={2}
            placeholder="Add a description that appears beneath the post..."
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
          />
        </div>
      )}
    </div>
  </div>
);
